import { Auth, API } from "aws-amplify";

async function placeBet(bot, raceID, selectionNumber, marketType, stake) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "PLACE_BET",
      message: {
        raceID,
        selectionNumber,
        marketType,
        stake
      }
    }
  });
}

async function kill(bot) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "KILL",
      message: {}
    }
  });
}

async function ping(bot) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "PING",
      message: {}
    }
  });
}

async function resultBet(bot, betID, outcome, betReturn, bsp) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "RESULT_BET",
      message: {
        betID,
        outcome,
        betReturn,
        bsp
      }
    }
  });
}

async function confirmBet(bot, betID, outcome, acceptedStake, transactionID) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "CONFIRM_BET",
      message: {
        betID,
        outcome,
        transactionID,
        acceptedStake
      }
    }
  });
}

async function restartBookie(bot, bookie) {
  if (bookie === "boombet") {
    bookie = "sportsbetting";
  }

  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "RESTART_BOOKIE",
      wait: 10,
      message: {
        bookie
      }
    }
  });
}

async function screenshotBookie(bot, bookie) {
  if (bookie === "boombet") {
    bookie = "sportsbetting";
  }

  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "SCREENSHOT_BOOKIE",
      wait: 10,
      message: {
        bookie
      }
    }
  });
}

async function screenshotBet(bot, date, bookie, betID) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "SCREENSHOT_BET",
      wait: 10,
      message: {
        date,
        bookie,
        bet_id: betID
      }
    }
  });
}

async function checkBetResults(bot) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "CHECK_RESULTS",
      wait: 10,
      message: {}
    }
  });
}

async function checkBetResultsForBookie(bot, bookie) {
  if (bookie === "boombet") {
    bookie = "sportsbetting";
  }

  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "CHECK_RESULTS",
      wait: 10,
      message: {
        bookie
      }
    }
  });
}

async function refreshUpcomingRaces(bot) {
  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "REFRESH_UPCOMING_RACES",
      wait: 10,
      message: {}
    }
  });
}

async function refreshUpcomingRacesForBookie(bot, bookie) {
  if (bookie === "boombet") {
    bookie = "sportsbetting";
  }

  return API.post("prod-slippy", "/controller/send", {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    },
    body: {
      bot,
      type: "REFRESH_UPCOMING_RACES",
      wait: 10,
      message: {
        bookie
      }
    }
  });
}

export {
  placeBet,
  resultBet,
  confirmBet,
  kill,
  ping,
  restartBookie,
  screenshotBookie,
  screenshotBet,
  checkBetResults,
  checkBetResultsForBookie,
  refreshUpcomingRaces,
  refreshUpcomingRacesForBookie
};
